import { Box, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import type { ReactNode } from 'react'

type StepLayoutProps = {
  title: string
  subtitle: string
  children: ReactNode
  aside: ReactNode
  asideWidth?: number
}

/** Two-column wizard step scaffold: heading + main column on the left,
 *  a sticky context column (tips / preview) on the right. */
export default function StepLayout({ title, subtitle, children, aside, asideWidth = 360 }: StepLayoutProps) {
  const theme = useTheme()
  const c = theme.affexy.colors

  return (
    <Box
      sx={{
        maxWidth: 1280,
        mx: 'auto',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: `1fr ${asideWidth}px` },
        gap: 5,
      }}
    >
      {/* minWidth: 0 — grid items default to min-width:auto, so wide content
          (e.g. a long uploaded-file name) would push the aside off-screen. */}
      <Stack spacing={2.75} sx={{ minWidth: 0 }}>
        <Box>
          <Typography variant="h3" sx={{ fontSize: 28 }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: 14.5, color: c.ink72, mt: 0.75, maxWidth: 640, lineHeight: 1.55 }}>
            {subtitle}
          </Typography>
        </Box>
        {children}
      </Stack>
      <Box
        component="aside"
        sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', gap: 2, position: 'sticky', top: 0, alignSelf: 'start', minWidth: 0 }}
      >
        {aside}
      </Box>
    </Box>
  )
}
